var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bolt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8281 2.38567C17.5372 2.24135 17.2496 2.2733 17.0553 2.32389C16.8618 2.37426 16.6741 2.46523 16.5068 2.55811C16.18 2.73962 15.7624 3.0266 15.2669 3.36712L4.39577 10.838C4.07799 11.0563 3.78724 11.2561 3.5801 11.4364C3.39142 11.6007 3.06575 11.9166 3.05873 12.3963C3.0558 12.596 3.10077 12.7935 3.18985 12.9722C3.40385 13.4016 3.83418 13.5453 4.07539 13.6117C4.34018 13.6846 4.68875 13.7388 5.06971 13.7981L8.66137 14.3569L6.26881 18.5824C5.98414 19.0851 5.74268 19.5115 5.59526 19.8433C5.51958 20.0137 5.44707 20.2053 5.41496 20.4005C5.38241 20.5983 5.3786 20.8803 5.54121 21.152C5.65469 21.3416 5.8164 21.4977 6.00988 21.6045C6.28711 21.7575 6.5688 21.7438 6.76531 21.7043C6.95923 21.6653 7.14824 21.5862 7.31582 21.5046C7.64228 21.3456 8.05993 21.0893 8.55233 20.7872L19.5495 14.0402C19.868 13.8448 20.1613 13.6649 20.3729 13.4988C20.5684 13.3453 20.9007 13.0522 20.9364 12.5822C20.9513 12.385 20.9193 12.1871 20.843 12.0047C20.6609 11.57 20.2532 11.3965 20.0193 11.3125C19.7661 11.2215 19.4311 11.1433 19.0673 11.0583L15.194 10.153L17.6473 5.48073C17.9268 4.94845 18.1624 4.49985 18.304 4.15386C18.3764 3.9768 18.4445 3.77957 18.4717 3.58152C18.4989 3.38261 18.4966 3.09327 18.3189 2.82144C18.197 2.63506 18.0276 2.48462 17.8281 2.38567Z",
    fill: "#444444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.30cb7438121c88b825fd8333a0369dbe.svg";
export { ForwardRef as ReactComponent };